module.exports = __webpack_public_path__ + "c8e5dff52e490500c8da53f07c234631.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-BoldItalic.eot
// module id = 411
// module chunks = 0